import { defineComponent as _defineComponent } from 'vue'
import { computed, onUnmounted } from 'vue'
  import { EditorModule } from '@/store/modules/editor'
  import MediaUploader from '@/components/common/MediaUploader.vue'
  import AudioPlayer from '@/components/AudioPlayer.vue'
  import TextRenderer from '@/components/editor/TextRenderer.vue'
  import useEditor from '@/composables/useEditor'
  import { CourseModule } from '@/store/modules/course'
  import EditAuthors from '@/components/editor/EditAuthors.vue'
  import useI18n from '@/composables/useI18n'
  import eventBus from '@/main'
  import type { PropType } from 'vue'
  import type { AudioFile, EditorLessonAudioFile, EditorStatePayload, LessonMap } from '@/services/interfaces/Course'
  import ReorderUpAndDown from '@/components/common/ReorderUpAndDown.vue'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AudioAuthor',
  props: {
    authorId: {
      type: String,
      default: '',
    },
    addAuthor: {
      type: Function as PropType<(authorId: string) => void>,
      required: true,
    },
    removeAuthor: {
      type: Function as PropType<() => void>,
      required: true,
    },
    setAudioUrl: {
      type: Function as PropType<(url: string) => void>,
      required: true,
    },
    showAudioTitle: {
      type: Boolean,
      default: false,
    },
    showRemoveAudioEntry: {
      type: Boolean,
      default: false,
    },
    showAddAuthor: {
      type: Boolean,
      default: false,
    },
    audioEditorId: String,
    audioFileId: String,
    audioUrl: String,
    editAuthorSubtext: String,
    currentIndex: Number,
    itemsLength: Number,
  },
  emits: ['remove-entry', 'move-down', 'move-up'],
  setup(__props) {

const props = __props;

  

  

  const route = useRoute()
  const { lessonAudioFiles } = useEditor(route)
  const { translateString } = useI18n()

  const showReorderButtons = computed(() => props.currentIndex !== undefined)

  const originalAudioTitle = computed(() => {
    const audioFile = CourseModule.originalLessonAudioFiles?.find((a) => a.id === props.audioFileId)
    return audioFile ? audioFile.title : ''
  })

  const authorSubtext = computed(() => {
    return props.editAuthorSubtext ? props.editAuthorSubtext : translateString('editor.editAuthorsSubtext')
  })

  const audioAuthor = computed(() => {
    const author = EditorModule.editorAllAuthors?.find((author) => author.id === props.authorId)
    return author ? [author] : []
  })

  const mutateAndQueueFunc = (audioEditorId: string) => {
    return async (data: EditorStatePayload) => {
      const changesPayload = EditorModule.editorChanges[data.path]?.find((c) => c.data.key === data.key)
      const audioFile: any =
        lessonAudioFiles.value?.find((a) => [audioEditorId].includes(a.editorId!)) ||
        lessonAudioFiles.value?.find((a) => a.id === props.audioFileId)

      const payload = Object.assign({}, data, {
        apiPayload: data.value,
        value: {
          editorId: audioEditorId || props.audioFileId,
          prevPropValue: (changesPayload?.data.value as LessonMap)?.prevPropValue ?? audioFile[data.property!] ?? '',
        },
      })
      await EditorModule.addEditorChange(payload)
      if (audioFile) eventBus.$set(audioFile, payload.property!, payload.apiPayload as string)
      EditorModule.subscribe({
        type: 'save',
        key: payload.key,
        callback: audioRedoCallback,
      })
      EditorModule.subscribe({
        type: 'discard',
        key: 'discard-' + payload.key,
        callback: audioUndoCallback,
      })
    }
  }

  const audioRedoCallback = (data: EditorStatePayload) => {
    if (!data) return
    const audioFile: EditorLessonAudioFile | AudioFile | undefined = lessonAudioFiles.value?.find(
      (a) => a.editorId === (data.value as LessonMap).editorId,
    )
    if (audioFile) (audioFile as any)[data.property!] = data.apiPayload as string
  }

  const audioUndoCallback = (data: EditorStatePayload) => {
    if (!data) return
    const audioFile = lessonAudioFiles.value?.find((a) => a.editorId === (data.value as LessonMap).editorId)
    if (audioFile) (audioFile as any)[data.property!] = (data.value as LessonMap).prevPropValue
  }

  onUnmounted(() => {
    EditorModule.unsubscribe({ type: 'discard', callback: audioUndoCallback })
    EditorModule.unsubscribe({ type: 'save', callback: audioRedoCallback })
  })

return { __sfc: true,props, route, lessonAudioFiles, translateString, showReorderButtons, originalAudioTitle, authorSubtext, audioAuthor, mutateAndQueueFunc, audioRedoCallback, audioUndoCallback, computed, onUnmounted, EditorModule, MediaUploader, AudioPlayer, TextRenderer, useEditor, CourseModule, EditAuthors, useI18n, eventBus, ReorderUpAndDown, useRoute }
}

})